import { call, put, takeEvery } from 'redux-saga/effects';
import { createNoticAPI, deleteNoticAPI, getNoticAPI, updateNoticAPI } from "../Services"
import { ADD_NOTIC, ADD_NOTIC_RED, DELETE_NOTIC, DELETE_NOTIC_RED, GET_NOTIC, GET_NOTIC_RED, UPDATE_NOTIC, UPDATE_NOTIC_RED } from "../Constant"

// / Create Notifaction Saga
function* createNoticSaga(action) {
    try {
        const response = yield call(createNoticAPI, action.payload);
        if (response && response.data) {
            yield put({ type: ADD_NOTIC_RED, data: response.data });
        } else {
            console.error("Create Notic API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in createNoticSaga:", error);
    }
}

// Get Notifaction Saga
function* getNoticSaga() {
    try {
        const response = yield call(getNoticAPI);
        if (response && response.data) {
            yield put({ type: GET_NOTIC_RED, data: response.data });
        } else {
            console.error("Get Notic API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in getNoticSaga:", error);
    }
}

// Delete Notifaction Saga
function* deleteNoticSaga(action) {
    try {
        const response = yield call(deleteNoticAPI, action.payload);
        if (response) {
            yield put({ type: DELETE_NOTIC_RED, data: action.payload });
        } else {
            console.error("Delete Notic API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in deleteNoticSaga:", error);
    }
}

// Update Notifaction Saga
function* updateNoticSaga(action) {
    try {
        const response = yield call(updateNoticAPI, action.payload);
        if (response) {
            yield put({ type: UPDATE_NOTIC_RED, data: action.payload });
        } else {
            console.error("Update Notic API returned invalid data:", response);
        }
    } catch (error) {
        console.error("Error in updateNoticSaga:", error);
    }
}

// Notifaction Saga (Watcher)
export function* noticSaga() {
    yield takeEvery(ADD_NOTIC, createNoticSaga);
    yield takeEvery(GET_NOTIC, getNoticSaga);
    yield takeEvery(DELETE_NOTIC, deleteNoticSaga);
    yield takeEvery(UPDATE_NOTIC, updateNoticSaga);
}
